import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 py-2 bg-white border-b-4 border-indigo-600" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "relative flex gap-2 items-center text-gray-500 text-sm capitalize" }
const _hoisted_5 = { class: "absolute right-0 z-20 w-48 py-1 mt-2 bg-white rounded-lg shadow-xl" }

import { ref } from "vue";
import { useSidebar } from "../hooks/useSidebar";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const dropdownOpen = ref(false);
const { isOpen } = useSidebar();
const notificationOpen = ref(false);
const loggedInUser = ref({
  name: localStorage.getItem("name"),
  role: localStorage.getItem("user_role_id") == "1" ? "Writer" : "Reviewer",
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
        class: "text-gray-500 focus:outline-none lg:hidden"
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("svg", {
          class: "w-6 h-6",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M4 6H20M4 12H20M4 18H11",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)
      ])),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "relative mx-4 lg:mx-0" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("div", { class: "relative" })
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(loggedInUser.value.name) + " | " + _toDisplayString(loggedInUser.value.role) + " ", 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dropdownOpen.value = !dropdownOpen.value)),
          class: "relative z-10 block w-8 h-8 overflow-hidden rounded-full shadow focus:outline-none"
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("img", {
            class: "object-cover w-full h-full",
            src: "https://images.unsplash.com/placeholder-avatars/extra-large.jpg?w=150&dpr=2&crop=faces&bg=%23fff&h=150&auto=format&fit=crop&q=60&ixlib=rb-4.1.0",
            alt: "Your avatar"
          }, null, -1)
        ])),
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dropdownOpen.value = false)),
          class: "fixed inset-0 z-10 w-full h-full"
        }, null, 512), [
          [_vShow, dropdownOpen.value]
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-150 ease-out transform",
          "enter-from-class": "scale-95 opacity-0",
          "enter-to-class": "scale-100 opacity-100",
          "leave-active-class": "transition duration-150 ease-in transform",
          "leave-from-class": "scale-100 opacity-100",
          "leave-to-class": "scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "flex px-4 py-2 rounded-md text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-5 w-5 mr-1",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    })
                  ], -1),
                  _createTextVNode(" Log out")
                ])),
                _: 1
              })
            ], 512), [
              [_vShow, dropdownOpen.value]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})